import type * as React from "react";

import { cn } from "./cn";

/**
 * A 16px ring in the action colour; inside a button it takes the button's
 * own text colour so it reads on a forest fill. Announced as "Loading".
 */
function Spinner({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      data-slot="spinner"
      role="status"
      aria-label="Loading"
      viewBox="0 0 24 24"
      fill="none"
      className={cn(
        "size-4 shrink-0 animate-spin text-primary in-data-[slot=button]:text-current",
        className,
      )}
      {...props}
    >
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke="currentColor"
        strokeWidth="2.5"
        opacity="0.2"
      />
      <path
        d="M21 12a9 9 0 0 0-9-9"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export { Spinner };
